(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["b2b-bulk-pricing"] && !Shopify.designMode) return;
  try {
    function b2bTooltipOpen(tip, btn) {
    tip.removeAttribute('hidden');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function b2bTooltipClose(tip, btn) {
    tip.setAttribute('hidden', '');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function b2bCloseAll(skip) {
    document.querySelectorAll('.b2b-shipping-tooltip:not([hidden])').forEach(function(tip) {
      if (tip === skip) return;
      var w   = tip.closest('.b2b-shipping-tooltip-wrapper');
      var btn = w && w.querySelector('.b2b-shipping-tooltip-trigger');
      b2bTooltipClose(tip, btn);
    });
  }

  document.addEventListener('click', function(e) {
    var triggerBtn = e.target.closest('.b2b-shipping-tooltip-trigger');
    
    if (triggerBtn) {
      
      e.stopPropagation();
      var wrap = triggerBtn.closest('.b2b-shipping-tooltip-wrapper');
      
      if (!wrap) return;
      var tip = document.querySelector('.b2b-shipping-tooltip');
      if (!tip) return;
      if (tip.hasAttribute('hidden')) {
        b2bCloseAll(tip);
        b2bTooltipOpen(tip, triggerBtn);
      } else {
        b2bTooltipClose(tip, triggerBtn);
      }
      return;
    }

    var closeBtn = e.target.closest('.b2b-shipping-tooltip__close');
    if (closeBtn) {
      e.stopPropagation();
      var tip2 = closeBtn.closest('.b2b-shipping-tooltip');
      if (!tip2) return;
      var wrap2 = tip2.closest('.b2b-shipping-tooltip-wrapper');
      var btn2  = wrap2 && wrap2.querySelector('.b2b-shipping-tooltip-trigger');
      b2bTooltipClose(tip2, btn2);
      return;
    }

    b2bCloseAll(null);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') b2bCloseAll(null);
  });
  } catch(e) { console.error(e); }
})();

})();
